import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// *DICCIONARIOS
import { moduloSeguridad } from '../../diccionarios/seguridadModulo';
import { buttons, mensajes, buttonsCss } from '../../diccionarios/diccionario';
// *COMPONENTES
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { AgGridAngular } from 'ag-grid-angular';
// *SERVICIOS
import { SesionService } from '../../services/sesion.service';
import { RolService } from '../../services/rol.service';
import { RolSesionService } from '../../services/rol-sesion.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
// *MODELOS
import { RolSeguridadModel } from '../../models/rolSeguridad.model';

@Component({
  selector: 'app-sesion',
  templateUrl: './sesion.component.html',
  styleUrls: ['./sesion.component.css']
})
export class SesionComponent implements OnInit {

  formulario: FormGroup;
  formularioSesion: FormGroup;
  sesionRol: string;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;
  mostrarSesion: boolean = false;

  @ViewChild('agGrid') agGrid: AgGridAngular;
  frameworkComponents: any;
  rowData: any[];
  rowSelection: any;
  columnDefs: any[];
  gridApi: any;
  gridColumnApi: any;
  textoBuscar: string;

  rowDataRol: any[];
  columnDefsRol: any[];

  DAT_BTNS;
  DAT_BTNCSS;
  DAT_MSG;

  textBoton: string;
  cmbListRol: RolSeguridadModel[];
  cmbAplicacion: any[] = [];

  diccionarioModulo: any = {};
  DAT_TITULOS: any;
  titulo: string;

  constructor(private fb: FormBuilder,
    private _util: UtilsService,
    private sesionService: SesionService,
    private commonFormService: CommonFormService,
    private rolService: RolService,
    private rolSesionService: RolSesionService) {
    this.diccionarioModulo = moduloSeguridad;
  }

  ngOnInit() {
    this.DAT_BTNS = moduloSeguridad.button.buttonsNombre;
    this.DAT_MSG = moduloSeguridad.mensajes;
    this.DAT_BTNCSS = moduloSeguridad.button.buttonsCss;
    this.DAT_TITULOS = moduloSeguridad.titulos.sesion;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      id: [''],
      descripcion: ['', [Validators.required, Validators.maxLength(50)]],
      codSesion: ['', [Validators.required, Validators.maxLength(70)]],
      application: ['', [Validators.required]]
    });

    this.formularioSesion = this.fb.group({
      sesionId: [''],
      rolId: ['', [Validators.required]]
    });

    this.gridComponent();
    this.getAllSesiones();
    this.getListaAplicacion();
    this.getAllRoles();
  }

  // *FUNCIONES
  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'APLICACION',
        field: 'application',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'DESCRIPCION',
        field: 'descripcion',
        sortable: true,
        filter: true,
        width: 320
      },
      {
        headerName: 'COD. SESION',
        field: 'codSesion',
        sortable: true,
        filter: true,
        width: 310
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.editarLinea.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminarLinea.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: buttonsCss.danger
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 170,
        cellRendererParams: {
          onClick: this.agregarRolSesion.bind(this),
          label: this.DAT_BTNS.agregarRol,
          colorBoton: buttonsCss.warning
        }
      }
    ];

    this.columnDefsRol = [
      {
        headerName: 'ROL',
        field: 'rolDescripcion',
        sortable: true,
        filter: true,
        // checkboxSelection: true,
        width: 300
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        //width: 200,
        cellRendererParams: {
          onClick: this.eliminarRol.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: buttonsCss.danger
        }
      }
    ];

    this.rowSelection = 'multiple';
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editarLinea({ rowData }) {
    this.commonFormService.abrirFormularioParaEditar(this, rowData);
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

  // *SERVICIOS
  getListaAplicacion() {
    this.sesionService.getAplicacion().subscribe((resp: any[]) => {
      this.cmbAplicacion = resp;
    });
  }

  getAllRoles() {
    this.rolService.getAll().subscribe((res: any) => {
      this.cmbListRol = res;
    });
  }

  eliminarLinea({ rowData }) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this.sesionService.eliminarSesionId(rowData.id),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    });
  }
  
  getAllSesiones() {
    this.sesionService.getAll().subscribe((res: any) => {
      this.rowData = res;
    });
  }

  guardarSesion() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this.sesionService.guardarSesion(this.formulario.value),
      }
    ).then((res: any) => {
      this.getAllSesiones();
      this.regresar();
    });
  }

  actualizarSesion() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this.sesionService.actualizarSesionId(this.formulario.getRawValue()),
      }
    ).then((res: any) => {
      this.getAllSesiones();
      this.regresar();
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarSesion();
      } else {
        this.guardarSesion();
      }
    } else {
      this.regresar();
    }
  }

  agregarRolSesion({ rowData }) {
    this.rowDataRol = [];
    this.mostrarSesion = true;
    this.sesionRol = rowData.id;
    this.formularioSesion.reset();
    this.formularioSesion.controls.sesionId.setValue(rowData.id);
    this.getRolSesion(rowData.id);
  }

  getRolSesion(id: string) {
    this.rolSesionService.getSesion(id).subscribe((resp: any) => {
      this.rowDataRol = resp;
    });
  }

  onGridReadyRol(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  eliminarRol({ rowData }) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this.rolSesionService.eliminarRolSesionId(rowData.rolId, rowData.sesionId),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    });
  }

  accionesRol(event) {
    if (event === 'guardar') {
      this.guardarRol();
    } else {
      this.formularioSesion.reset();
      this.mostrarSesion = false;
    }
  }

  guardarRol() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this.rolSesionService.guardarRolSesion(this.formularioSesion.getRawValue()),
      }
    ).then((res: any) => {
      this.getRolSesion(this.sesionRol);
    });
  }

}
